var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"dense":!_vm.AppIsSmall}},[_vm._l((_vm.items),function(item,i){return [_c('app-list-item',{key:i.toString(),attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }